import React from 'react';
import Logo from '../assets/images/logo.png';

let styles = {
    formHeaderTop: {
        marginTop: 15, 
        marginBottom: 15, 
        fontSize: 20,
        color: '#4b4b4b',
        fontWeight: '700', 
        textAlign: 'center',
        textTransform: 'uppercase'
    },
    informationPadding: {
      paddingHorizontal: 20
    },
    infoText: {
      color: 'black',
      fontWeight: '400',
      fontSize: 12,
      marginBottom: 15
    },
}

class NotFoundPage extends React.Component {

    constructor(props) {
        super(props);

        this.onReturnToHomePageButtonPress = this.onReturnToHomePageButtonPress.bind(this);

    }

    componentDidMount(){
        // 
    }

    onReturnToHomePageButtonPress(){
        this.props.history.push('/');
    }

    render() {

        return (    
            <div className="breakpointContainer">
                <div className="login-section"> 
                    <img src={Logo} className="loginlogo" />

                    <div className="auth-selection-window">                  
                        <div style={styles.formHeaderTop}>Page Not Found</div>
                    </div>

                    <div style={styles.informationPadding}>                  
                        <div style={styles.infoText}>The page you are looking for doesn't exist or has been moved.</div>
                    </div>

                    <div className="auth-selection-window">                  
                        <div className="auth-button">
                            <a  
                                className={'selected lessPadding'}
                                onClick={() => {
                                    this.onReturnToHomePageButtonPress()
                                }}
                            >
                                <p className={'selected-button-text'}>Return To Homepage</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NotFoundPage;